import { Container, Icon, Left, Middle, Right } from './Footer.Elemnet';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <Container>
      <Left>Copyright ©2022</Left>
      <Middle>Designed & Developed by SUMAIL.</Middle>
      <Right>
        <Icon onClick={scrollToTop}>
          <svg
            width="30"
            height="30"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.875 24.2711L31.2777 27.017C31.7779 27.5886 32.6463 27.6463 33.2181 27.1464C33.7895 26.6463 33.8473 25.7776 33.3473 25.2061L28.5348 19.7061C28.2738 19.4077 27.8965 19.2366 27.5 19.2366C27.1035 19.2366 26.7263 19.4077 26.4652 19.7061L21.6527 25.2061C21.1527 25.7776 21.2106 26.6463 21.7821 27.1464C22.3536 27.6463 23.2222 27.5886 23.7223 27.017L26.125 24.271V34.3885C26.125 35.1478 26.7406 35.7635 27.5 35.7635C28.2596 35.7635 28.875 35.1478 28.875 34.3885V24.2711ZM11 44C7.96243 44 5.5 41.5376 5.5 38.5V16.5C5.5 13.4624 7.96243 11 11 11H44C47.0377 11 49.5 13.4624 49.5 16.5V38.5C49.5 41.5376 47.0377 44 44 44H11ZM8.25 38.5C8.25 40.0188 9.48123 41.25 11 41.25H44C45.5188 41.25 46.75 40.0188 46.75 38.5V24.75H36.2076C36.0385 24.2657 35.7756 23.805 35.417 23.3952L30.6045 17.8952C29.8213 17.0001 28.6896 16.4866 27.5 16.4866C26.3106 16.4866 25.179 17.0001 24.3957 17.8952L19.5832 23.3952C19.2246 23.805 18.9617 24.2657 18.7926 24.75H8.25V38.5Z"
              fill="#FFFCFC"
            />
          </svg>
        </Icon>
      </Right>
    </Container>
  );
};

export default Footer;
